import { effect, inject } from "@angular/core";
import { DARK_THEME_LOGO_PATH, FOOTER_TEXT, LIGHT_THEME_LOGO_PATH, LOGO_ALT_TEXT, SMALL_LOGO_NO_TEXT_PATH } from "@itm/constants";
import { LayoutService } from "@itm/services";

export abstract class BaseLayout {
    footerBranding: string = FOOTER_TEXT;
    lightThemeLogoPath: string = LIGHT_THEME_LOGO_PATH;
    darkThemeLogoPath: string = DARK_THEME_LOGO_PATH;
    smallLogoNoTextPath: string = SMALL_LOGO_NO_TEXT_PATH;
    logoAltText: string = LOGO_ALT_TEXT;
    
    protected readonly _layoutService = inject(LayoutService);
    isMobile = this._layoutService.isMobileView;

    constructor(){
        effect(() => {
            this.isMobile = this._layoutService.isMobileView;
        })
    }
}